module.exports = __webpack_public_path__ + "img/Kits.03110f16.jpg";